import { useEffect } from 'react';
import useMeasure from 'react-use-measure';

interface IGetSize {
    onResize(size: { width: number; height: number }): void;
}

export const GetSize = (props: IGetSize) => {
    const [ref, bounds] = useMeasure();

    useEffect(() => {
        props.onResize(bounds);
    }, [bounds]);

    return (
        <div
            ref={ref}
            style={{ width: '100%', height: '1px', position: 'absolute' }}
        ></div>
    );
};
